import Lenis from 'lenis'

let instance: Lenis | null = null

export function getLenis() {
	return instance
}

export function setupLenis() {
	// autoRaf owns the frame loop — never add a manual raf() loop alongside it,
	// or Lenis steps twice per frame and eases at double the configured lerp.
	instance = new Lenis({
		autoRaf: true,
		lerp: 0.125,
		smoothWheel: true,
	})
}
